import Steps from "../../../../components/steps/steps.component";
import Step1 from "./components/setp1.view";
import Step2 from "./components/step2.view";
import Step3 from "./components/step3.view";
import ViewBase from "../../../view-base.view";

export default function CampaignRegisterView() {
	ViewBase.call(this);
	let step = 1;

	let _campaignName = "";
	let _campaignId = null;
  let _campaignViewState = {};

	const steps = [
		{ id: 1, title: this.getText('LT00001224', 'Register Campaign') }, { id: 2, title: this.getText('LT00001228', 'Upload Mapping') }, { id: 3, title: this.getText('LT00000129', 'Complete') }
	]

	let goBackList = () => { };

	const onBack = () => {
		if (step == 1) {
			return;
		} else {
			step--;
		}
	}

	const onNext = (result) => {
		if (result.campaignID) {
			_campaignId = result.campaignID
		}
		if (step == 3) {
			return;
		} else {
			step++;
		}
	}

	return {
		oninit: ({ attrs: { onGoBackList, campaignId, campaignName, 
			campaignViewState}}) => {
			if (onGoBackList) {
				goBackList = onGoBackList;
			}

			if (campaignId) {
        _campaignId = campaignId;
      }
			if (campaignName){
				_campaignName = campaignName
			}

			if (campaignViewState) {
				_campaignViewState = campaignViewState
			}
		},
		view: (vnode) => {
			return [
				m('.row',
				_campaignName != "" &&
          m('.w-100',
            m('h2',
              m('i.bi.bi-arrow-left.cursor-pointer', {
                onclick: () => {
                  goBackList();
                }
              }),
              `[Update] ${_campaignName}`
            )
          ),
					m('.card',
						m('.card-body', [
							m(Steps, { currentStep: step, steps: steps }),
							step == 1 &&
							m(Step1, {
								campaignId: _campaignId,
								onNext: onNext,
								campaignViewState: _campaignViewState
							}),
							step == 2 &&
							m(Step2, {
								campaignId: _campaignId,
								readonly: false,
								onNext: onNext,
								onBack: onBack
							}),
							step == 3 &&
							m(Step3, {
								readonly: false,
								campaignId: _campaignId,
								campaignName: _campaignName,
								onBack: onBack,
								goBackList: goBackList,
								onViewCampaign: vnode.attrs.onViewCampaign,
								campaignViewState: _campaignViewState
							})
						])
					)
				),
				this.getBaseViews()
			]
		}
	}
}